module.exports = __webpack_public_path__ + "img/linkedin-in.6ee7d18e.svg";